import React from "react";
import { Flex } from "../FlexHelpers";
import { colors } from "../../colors/color";
import { IconWithText } from "./IconWithText";

export function ActionPointCounterCompositeIcon(props:{
    actionpoints:{ done:boolean, deadline:Date | null }[]
}) {
    const total = props.actionpoints.length;
    const deadlinePassedCount = props.actionpoints.filter(ap => !ap.done && ap.deadline && ap.deadline < new Date()).length;
    const completedCount = props.actionpoints.filter(ap => ap.done).length;

    return (
        <ActionPointSummaryCounterCompositeIcon
            actionPointCount={total}
            actionPointDoneCount={completedCount}
            actionPointDeadlinePassedCount={deadlinePassedCount}
        />
    );
}

export function ActionPointSummaryCounterCompositeIcon(props:{
    actionPointCount: number,
    actionPointDoneCount: number,
    actionPointDeadlinePassedCount: number, // Not including done ones
}) {
    let state:'no-actionpoints' | 'deadline-passed' | 'all-completed' | 'in-progress' 
        = 'no-actionpoints';

    if(props.actionPointCount > 0)
    {
        if(props.actionPointDoneCount === props.actionPointCount) {
            state = 'all-completed';
        }
        else if(props.actionPointDeadlinePassedCount > 0) {
            state = 'deadline-passed';
        }
        else {
            state = 'in-progress';
        }
    }

    return (
        <>
            {state === 'no-actionpoints' &&
                <APComponent
                    iconVariant="passive"
                    total={{ count: 0, color: colors.text.muted }}
                    counter={{ count: 0, color: colors.text.muted }}
                    tooltipContent="Ingen handlepunkter"
                />
            }

            {state === 'all-completed' &&
                <APComponent
                    iconVariant="success"
                    total={{ count: props.actionPointCount, color: colors.text.normal }}
                    counter={{ count: props.actionPointCount, color: colors.text.normal }}
                    tooltipContent="Alle handlepunkter er gennemført"
                />
            }

            {state === 'deadline-passed' &&
                <APComponent
                    iconVariant="error"
                    total={{ count: props.actionPointCount, color: colors.text.normal }}
                    counter={{ count: props.actionPointDeadlinePassedCount, color:colors.text.state.error, bold:true }}
                    tooltipContent={` ${props.actionPointDeadlinePassedCount} handlepunkt(er) har overskredet deadline`}
                />
            }

            {state === 'in-progress' &&
                
                <APComponent
                    iconVariant="default"
                    total={{ count: props.actionPointCount, color: colors.text.normal }}
                    counter={{ count: props.actionPointDoneCount, color: colors.text.normal }}
                    tooltipContent={
                        props.actionPointDoneCount === 0
                        ? 'Ingen handlepunkter er gennemført'
                        : `${props.actionPointDoneCount} handlepunkt(er) er gennemført`}
                />
            }
        </>
    );

}


function APComponent(props:{
    iconVariant: 'passive' | 'default' | 'success' | 'error',
    counter:{ count:number, color:string, bold?:boolean },
    total:{ count:number, color:string },
    tooltipContent: string,
}) {
    return (
        <IconWithText tooltipContent={props.tooltipContent} icon="assignment_turned_in" variant={props.iconVariant}>

                <Flex flexDirection="row" alignItems="center" gap={2}>
                    
                    {props.counter.bold 
                        ? <span style={{ fontWeight:500, color:props.counter.color}}>{props.counter.count}</span>
                        : <span style={{color:props.counter.color}}>{props.counter.count}</span>
                    }

                    <span style={{color:props.total.color}}>/</span>
                    
                    <span style={{color:props.total.color}}>{props.total.count}</span>

                </Flex>
        </IconWithText>
    );
}